module.exports = __webpack_public_path__ + "static/img/3_1_1_1.808f313b.jpg";